// extracted by mini-css-extract-plugin
export default {"wrap-week":"ChooseWeek_wrap-week__REyl3","week":"ChooseWeek_week__bxtno","week__button":"ChooseWeek_week__button__1xKeU","week__text":"ChooseWeek_week__text__DZMZU"};